import { render } from "./imgViewDialog.vue?vue&type=template&id=6b27726c&scoped=true"
import script from "./imgViewDialog.vue?vue&type=script&lang=js"
export * from "./imgViewDialog.vue?vue&type=script&lang=js"

import "./imgViewDialog.vue?vue&type=style&index=0&id=6b27726c&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b27726c"]])

export default __exports__